var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.167 0.328125L15.3337 5.57813V18.4115L21.167 13.1615V0.328125ZM6.58366 3.82813C4.30866 3.82813 1.85866 4.29479 0.166992 5.57813V22.6815C0.166992 22.9731 0.458659 23.2648 0.750326 23.2648C0.866992 23.2648 0.925326 23.1831 1.04199 23.1831C2.61699 22.4248 4.89199 21.9115 6.58366 21.9115C8.85866 21.9115 11.3087 22.3781 13.0003 23.6615C14.5753 22.6698 17.4337 21.9115 19.417 21.9115C21.342 21.9115 23.3253 22.2731 24.9587 23.1481C25.0753 23.2065 25.1337 23.1831 25.2503 23.1831C25.542 23.1831 25.8337 22.8915 25.8337 22.5998V5.57813C25.1337 5.05313 24.3753 4.70313 23.5003 4.41146V20.1615C22.217 19.7531 20.817 19.5781 19.417 19.5781C17.4337 19.5781 14.5753 20.3365 13.0003 21.3281V5.57813C11.3087 4.29479 8.85866 3.82813 6.58366 3.82813Z",
    fill: "#070707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogInactive);
export default __webpack_public_path__ + "static/media/blogInactive.6b5ba1288e6928e0bc22ef3f2ca1e523.svg";
export { ForwardRef as ReactComponent };